import { createAsyncThunk } from "@reduxjs/toolkit";

import { Reporter } from "./reporterTypes";
import api from "@/lib/axios";
import { isAxiosError } from "axios";

export const fetchReporterInformation = createAsyncThunk<
  Reporter[],
  number,
  { rejectValue: string }
>("reporter/fetchReporterInformation", async (caseId, { rejectWithValue }) => {
  try {
    const response = await api.get<Reporter[]>(
      `/reporter_information/${caseId}`,
      {
        headers: { accept: "application/json" },
      }
    );
    return response.data;
  } catch (error) {
    if (isAxiosError(error)) {
      return rejectWithValue(error.message);
    }

    return rejectWithValue("An unknown error occurred");
  }
});
